import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';

import type {
  TextEffectsSharedDefinition,
  TextEffectsSharedMapperProps,
} from '../TextEffectsShared.types';
import type { LinkProps } from '@wix/editor-elements-definitions';

export const props = withCompInfo<
  TextEffectsSharedMapperProps,
  TextEffectsSharedDefinition
>()(['compData'], ({ compData }) => {
  const { link, ...restCompData } = compData;

  return {
    ...restCompData,
    link: link?.resolvedLink as unknown as LinkProps,
  };
});

export const stateRefs = withStateRefsValues(['reducedMotion']);

export default createComponentMapperModel({
  props,
  stateRefs,
});
